import { render, staticRenderFns } from "./group-panel.vue?vue&type=template&id=83bd59e6&scoped=true&"
import script from "./group-panel.vue?vue&type=script&lang=js&"
export * from "./group-panel.vue?vue&type=script&lang=js&"
import style0 from "./group-panel.vue?vue&type=style&index=0&id=83bd59e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bd59e6",
  null
  
)

export default component.exports